import { fromClientsDTO } from "features/utils/dto";
import { usePitcher } from "features/utils/usePitcher";
import { useEffect, useState } from "react";

export function usePitcherClients() {
  const pitcher = usePitcher();
  const getState = () => ({
    current: pitcher.currentClient,
    clients: fromClientsDTO(
      pitcher.clients.client.getClients(),
      pitcher.currentClient,
    ),
  });
  const [clientsState, setClientsState] = useState(getState());

  useEffect(() => {
    const reconnectedDisposer = pitcher.onReconnected(() =>
      setClientsState(getState()),
    );
    const clientsUpdateDisposer = pitcher.clients.client.onClientsUpdated(() =>
      setClientsState(getState()),
    );

    return () => {
      reconnectedDisposer.dispose();
      clientsUpdateDisposer.dispose();
    };
  }, []);

  return clientsState;
}
